module.exports = __webpack_public_path__ + "img/informacion-basica.dd3b4eb5.jpg";